import React from 'react'

import numeral from 'numeral'

import { shape, number, string, object } from 'prop-types'

import Tooltip from 'Pods/Shared/Tooltip'

import EarningsChart from './EarningsChart'
import StatsNumber from '../StatsNumber'
import StatsNumberContainer from '../StatsNumberContainer'
import EarningsTooltip from './EarningsTooltip'

function Earnings({ data }) {
  const averageIncomeTitle = 'Average monthly income of your last 6 months on CGTrader.'
  const averageIncomeTitleShort = 'Your average monthly income on CGTrader.'

  return (
    <div className="earnings-container">
      <div className="row">
        <div className="col-12 col-sm-6">
          <StatsNumberContainer
            tooltipText={data.account_age_in_months >= 6 ? averageIncomeTitle : averageIncomeTitleShort}
            tooltipId="average-income"
            value={data.earnings.average}
            title="Average"
            format="$0,0.00a"
          />
        </div>
        <div className="col-12 col-sm-6">
          <div className="stats-tooltip-container earnings-month-income">
            <StatsNumber value={data?.earnings?.total_by_period || 0} title="Selected period" format="$0,0.00a" />
            {data.earnings.last_sale.price && (
              <div className="stats-tooltip-container">
                <Tooltip
                  tooltipClassName="tooltip--medium"
                  id="dashboard__stats-models-last-sale"
                  content={
                    <EarningsTooltip
                      model={data.earnings.last_sale.title}
                      price={data.earnings.last_sale.price}
                      date={data.earnings.last_sale.created_at}
                    />
                  }
                >
                  <div className="earnings-month-income__value">
                    <a href="/profile/sales#latest-sales">
                      + {numeral(data.earnings.last_sale.price).format('$0,0.00a')}
                    </a>
                  </div>
                </Tooltip>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <EarningsChart data={data.earnings.chart_data} />
        </div>
      </div>
    </div>
  )
}

Earnings.propTypes = {
  data: shape({
    earnings: shape({
      total_by_period: number.isRequired,
      average: number.isRequired,
      total: number.isRequired,
      chart_data: object.isRequired,
      last_sale: shape({
        title: string,
        path: string,
        created_at: string,
        price: number,
      }),
    }).isRequired,
  }).isRequired,
}

export default Earnings
